import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { Brand } from "@/components/landing/SiteHeader";
import { MandateForm } from "@/components/mandate/MandateForm";
import { MandateSign } from "@/components/mandate/MandateSign";
import { MandateDone } from "@/components/mandate/MandateDone";
import { api, formatErr } from "@/lib/api";

const STEPS = ["Dati del mandato", "Firma", "Completato"];

export default function Mandate() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");

  const load = () => api.get(`/public/mandate/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(formatErr(e)));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const st = info?.mandato?.status;
  const step = !st ? 0 : ["caricato", "validato"].includes(st) ? 2 : 1;

  return (
    <main className="min-h-screen bg-slate-50" data-testid="mandate-page">
      <header className="bg-navy"><div className="max-w-5xl mx-auto px-5 h-20 flex items-center justify-between"><Brand light />
        <span className="hidden sm:flex items-center gap-2 text-xs text-slate-300"><ShieldCheck className="h-4 w-4 text-gold" /> Connessione protetta</span></div></header>
      <div className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        {err && <p data-testid="mandate-error" className="text-red-700 bg-red-50 border border-red-200 rounded-lg p-4">{err}</p>}
        {!info && !err && <Loader2 className="h-8 w-8 animate-spin mx-auto text-navy" />}
        {info && (
          <>
            <p className="text-xs uppercase tracking-[0.3em] text-gold-dark font-semibold">Mandato professionale</p>
            <h1 className="font-serif text-4xl sm:text-5xl text-navy mt-2">Gentile {info.cliente.nome} {info.cliente.cognome}</h1>
            <ol className="flex gap-2 mt-8 mb-8" data-testid="mandate-stepper">
              {STEPS.map((s, i) => (
                <li key={s} className={`flex-1 border-t-2 pt-2 text-xs sm:text-sm ${i <= step ? "border-gold text-navy font-semibold" : "border-slate-200 text-slate-400"}`}>
                  <span className="font-mono mr-1">{i + 1}.</span>{s}
                </li>
              ))}
            </ol>
            {step === 0 && <MandateForm token={token} info={info} onDone={load} />}
            {step === 1 && <MandateSign token={token} info={info} onDone={load} onEdit={() => setInfo({ ...info, mandato: null })} />}
            {step === 2 && <MandateDone token={token} info={info} />}
          </>
        )}
      </div>
    </main>
  );
}
